import React from "react"
import "./VotingCampaign.scss"
import { StaticImage } from "gatsby-plugin-image"
import { Player } from "@lottiefiles/react-lottie-player"
import Division from "@lotties/division.json"
import DivisionShort from "@lotties/division-short.json"

const VotingCampaign = () => {
  return (
    <>
      <section className="voting-campaign">
        <div className="voting-campaign-content" id="charaforio">
          <div className="voting-campaign-inner">
            <h2 className="section-title voting-campaign-title">
              Share your V4Mirai fan art with us!
            </h2>
            <p className="voting-campaign-text">
              Share your V4Mirai fan art on Charaforio and join us in making the
              live concert unforgettable! Earn exciting rewards by completing
              community missions!
            </p>
            <div className="voting-campaign-img">
              <StaticImage
                src="../../images/kv-charaforio.jpg"
                alt="Help us color V4Mirai 1st Live Concert -Mirai Wonderland- with your Likes and Fanart!"
              />
            </div>
            <a
              className="voting-campaign-button"
              target="_blank"
              rel="noreferrer"
              href="https://charaforio.com/ja/event/01JAA7C8NNTMF08W7W193XVMTB/SubEvent_01JCKZX2VH83H0VKZEQ385HQ2Q"
              data-gtm-click="fanArt-votingButton"
            ></a>
          </div>
        </div>
        <div className="voting-campaign-ornament">
          <Player className="deco-line4-sp" autoplay loop src={DivisionShort} />
          <Player className="deco-line4" autoplay loop src={Division} />
        </div>
      </section>
    </>
  )
}

export default VotingCampaign
